import { Inject, Injectable, InjectionToken } from '@angular/core';
import { map, distinctUntilChanged } from 'rxjs';
import { ConsentService } from './consent.service';

export type AnalyticsAdapter = {
  initialize: () => void;
};

export const ANALYTICS_ADAPTER = new InjectionToken<AnalyticsAdapter>('ANALYTICS_ADAPTER');

export class NoopAnalyticsAdapter implements AnalyticsAdapter {
  initialize(): void {
    return;
  }
}

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  private started = false;
  private initialized = false;

  constructor(
    private consentService: ConsentService,
    @Inject(ANALYTICS_ADAPTER) private adapter: AnalyticsAdapter
  ) {}

  start(): void {
    if (this.started) {
      return;
    }
    this.started = true;
    this.consentService.state$
      .pipe(
        map((consent) => Boolean(consent?.analytics)),
        distinctUntilChanged()
      )
      .subscribe((allowed) => {
        if (allowed && !this.initialized) {
          this.adapter.initialize();
          this.initialized = true;
          if (typeof window !== 'undefined') {
            (window as { __noisyUserAnalyticsInitialized?: boolean }).__noisyUserAnalyticsInitialized = true;
          }
        }
      });
  }
}
